import i18next from 'i18next'
import { GetServerSidePropsContext } from 'next'

import { MetasProps } from '../components/Metas'
import { app } from '../configuration'

export const transformSeoToMetas = (asPath: string, seo?: any): MetasProps => {
  return {
    applicationName: i18next.t('applicationName'),
    locale: 'fr_FR',
    title: seo?.title ?? '',
    description: seo?.description ?? '',
    image: seo?.picture ? app.APP_URL + seo?.picture : '', // todo transform picture ?
    robots: seo?.robots ?? '',
    url: app.APP_URL + asPath,
  }
}

export function setDefaultCacheHeader(context: GetServerSidePropsContext) {
  return context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )
}

export function isMaintenance(token?: any) {
  if (token === app.MAINTENANCE_TOKEN) {
    return false
  }
  return app.MAINTENANCE_MODE === 'true'
}
